import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/inventoryTxn", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/inventoryTxn/csv", params);
};

const upsert = data => {
  return restApi.post("/api/inventoryTxn/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/inventoryTxn/${ids}`);
};

const getRecentTxnDate = (params) => {
  return restApi.get("/api/inventoryTxn/recent-date", { params });
};
const inventoryTxnService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
  getRecentTxnDate
};

export default inventoryTxnService;